import { fetchFollows } from 'utils/queries/follows'

import { Follow } from 'types/follow'
import { UserType } from 'types/user'

import { useFollows } from './useFollows'
import { useQuery } from './useQuery'

export const useFriends = (userId: string | undefined) => {
  const { data: follows } = useFollows(userId)

  const friendsQuery = useQuery<Array<UserType>>(['friends', userId], async () => {
    const friends: Array<UserType> = []
    const followerPromises: Array<Promise<void | Follow[] | []>> = []
    if (follows && follows.length > 0) {
      follows.map((follow) => {
        followerPromises.push(
          fetchFollows({ userId: follow.trainer.id }).then((followsForOtherUser) => {
            followsForOtherUser.map((otherUserFollow) => {
              if (otherUserFollow.trainer.id === userId) {
                friends.push(follow.trainer)
              }

              return true
            })
          }),
        )

        return true
      })

      await Promise.all(followerPromises)
    }

    return friends
  })

  return {
    ...friendsQuery,
  }
}
